export const getStyled = (theme) => ({
  ticketHeader: {
    display: 'flex',
    background: theme.custom.colors.tabHeaderBackground,
    flex: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    height: '65px',
  },
});
